import React from 'react';
import { FiFacebook, FiTwitter, FiInstagram, FiLinkedin } from "react-icons/fi";
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const teamData = [
    {
        image: 'team-dark-01',
        name: 'Akshit Sharma',
        designation: 'Founder & CEO',
        location: 'Shimla, Himachal Pradesh', 
        description: 'Yes, I am the Founder and CEO. Nice to Meet You!',
        socialNetwork: [
            {
                icon: <FiFacebook />,
                url: 'https://facebook.com/buddy.akshit'
            },
            {
                icon: <FiTwitter />,
                url: 'https://twitter.com/buddy.akshit'
            },
            {
                icon: <FiInstagram />,
                url: 'https://instagram.com/buddy.akshit'
            },
        ]
       
    },
    {
        image: 'team-dark-02',
        name: 'Aditya Choudhary',
        designation: 'UI/UX Designer',
        location: 'Haryana', 
        description: 'Yes, I am a UI/UX Designer. Nice to Meet You!',
        socialNetwork: [
            {
                icon: <FiFacebook />,
                url: '#'
            },
            {
                icon: <FiTwitter />,
                url: '#'
            },
            {
                icon: <FiLinkedin />,
                url: '#'
            },
        ]
      
    },
    {
        image: 'team-dark-03',
        name: 'Vineet Kumar',
        designation: 'Android Developer',
        location: 'Guwardu, Himachal Pradesh', 
        description: 'Yes, I am Android Developer. I like Flutter then Android Studio.',
        socialNetwork: [
            {
                icon: <FiFacebook />,
                url: '#'
            },
            {
                icon: <FiTwitter />,
                url: '#'
            },
            {
                icon: <FiInstagram />,
                url: '#'
            },
        ]
        
    },
    {
        image: 'team-dark-04',
        name: 'Vishal Kumar',
        designation: 'Full-Stack Developer',
        location: 'Hamirpur, Himachal Pradesh', 
        description: 'Yes, I am a Full-Stack Developer. I have a passion for Development',
        socialNetwork: [
            {
                icon: <FiFacebook />,
                url: '#'
            },
            {
                icon: <FiTwitter />,
                url: '#'
            },
            {
                icon: <FiInstagram />,
                url: '#'
            },
        ]
        
    },
]


const TeamFour = ({column , teamStyle}) => {
    return (
        <div className="row row--15">
            {teamData.map((data, index) => (
                <div className={`${column}`} key={index}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`rn-team ${teamStyle}`}>
                            <div className="inner">
                                <figure className="thumbnail">
                                    <img src={`./images/team/${data.image}.jpg`} alt="Corporate React Template" />
                                </figure>
                                <figcaption className="content">
                                    <div className="team-info">
                                        <h2 className="title">{data.name}</h2>
                                        <h6 className="subtitle theme-gradient">{data.designation}</h6>
                                        <div className="team-form">
                                            <span className="location">{data.location}</span>
                                        </div>
                                    </div>
                                </figcaption>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default TeamFour;
